class AddToCartButton extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();

    this.buttonEl = this.shadowRoot.querySelector("button");
    this.formEl = this.shadowRoot.querySelector("form");
    this.fieldset = this.shadowRoot.querySelector("fieldset");
    this.formEl?.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(e.target);
      const {data, ...formValues} = Object.fromEntries(formData);
      this.fieldset.disabled = true;
      const parsedValue = JSON.parse(decodeURIComponent(data) || "[]");
      let fieldset = this.fieldset;
      parsedValue?.forEach(product => {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: "1",
            id: product?.variantId,
            ...formValues
          },
          dataType: 'json',
          success: function(item) {
            // Display a success message or update the cart UI
            console.log('Item added to cart!');
            // Optionally update the cart count or cart items
            fieldset.disabled = false;
            updateCart();
          },
          error: function(XMLHttpRequest, textStatus) {
            // Display an error message
            fieldset.disabled = false;
            var response = JSON.parse(XMLHttpRequest.responseText);
            console.log('Error: ' + response.description);
          }
        });
      })
      function updateCart() {
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          dataType: 'json',
          success: function(cart) {
            // Update the cart UI with the cart data
            fieldset.disabled = false;
            $('#cart-count').text(cart.item_count);
          }
        });
      }
    })
  }

  static get observedAttributes() {
    return ['class', 'data'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name == 'class') this.class = newValue;
    if (name == 'data') this.data = newValue;
  }

  set class(value) {
    this.buttonEl.setAttribute("class", value);
  }

  set data(value) {
    const node = document.createElement("input");
    node.hidden = true;
    node.setAttribute("name", "data");
    node.setAttribute("value", value);
    this.fieldset.appendChild(node);
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  template() {
    return `
      <form>
        <fieldset>
          <input hidden name="form_type" value="product" />
          <input hidden name="utf8" value="✓" />
          <input hidden name="sections" value="cart-drawer,cart-icon-bubble" />
          <input hidden name="Size (US)" value="7.5" />
          <button type="submit" class="x-primary-outline">
            <slot></slot>
          </button>
        </fieldset>
      </form>
    `;
  }

  css() {
    return `
      :host {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      fieldset {
        margin: 0;
        padding: 0;
        border: none;
        outline: none;
      }

      fieldset:disabled {
        opacity: .5;
        pointer-events: none;
      }

      button {
        width: 100%;
      }

      .x-primary-outline {
        height: 38px;
        border-radius: 10px;
        border: 1px solid #14972C;
        font-family: "GT America", sans-serif;
        font-size: 12px;
        font-weight: 700;
        line-height: 14.4px;
        text-align: center;
        color: #14972C;
        text-transform: uppercase;
        background: transparent;
        cursor: pointer;
        transition: all 200ms ease-in-out;
      }

      .x-primary-outline:hover {
        background: #14972C;
        color: #fff;
      }

      .x-primary {
        height: 38px;
        border-radius: 10px;
        border: 1px solid #14972C;
        font-family: "GT America", sans-serif;
        font-size: 12px;
        font-weight: 700;
        line-height: 14.4px;
        text-align: center;
        color: #fff;
        text-transform: uppercase;
        background: #14972C;
        cursor: pointer;
        transition: all 200ms ease-in-out;
      }

      .x-primary:hover {
        background: #fff;
        color: #14972C;
      }

      @media screen and (min-width: 1024px) {
        .x-primary-outline {
          height: 54px;
          padding: 16px 24px 16px 24px;
          font-size: 18px;
          line-height: 21.6px;
        }

        .x-primary {
          height: 54px;
          padding: 16px 24px 16px 24px;
          font-size: 18px;
          line-height: 21.6px;
        }
      }
    `;
  }
}

customElements.define("x-add-to-cart", AddToCartButton);
